import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import { Input } from 'shared/components';
import { withTranslation } from 'react-i18next';
import isArray from 'lodash/isArray';
import './CheckboxList.scss';

class CheckboxList extends Component {
  constructor(props) {
    super(props);
    const { errors } = props;
    this.state = {
      errors,
    };
  }

  componentDidUpdate(prevProps) {
    const { errors } = this.props;
    if (prevProps.errors !== errors) {
      this.setState({
        errors,
      });
    }
  }

  getCheckbox(checkbox) {
    const { disabledList } = this.props;

    return (
      <Input
        type="checkbox"
        name={`${checkbox.key}`}
        id={`checklist-item-${checkbox.key}`}
        key={uniqueId('checklist-item-')}
        value={checkbox.value}
        checked={checkbox.checked}
        onChange={this.props.onChange}
        disabled={checkbox.disabled || disabledList}>
        <label
          htmlFor={`checklist-item-${checkbox.key}`}
          dangerouslySetInnerHTML={{ __html: checkbox.label }}
        />
      </Input>
    );
  }

  render() {
    const { errors } = this.state;
    const { checkboxes, className, title, description } = this.props;

    return (
      <div className="CheckboxList">
        {title && <h6 className="title" dangerouslySetInnerHTML={{ __html: title }}></h6>}

        {errors ? (
          isArray(errors) ? (
            errors.map((error) => (
              <span className="text-error text-small" key={error}>
                {this.props.t(error)}
              </span>
            ))
          ) : (
            <span className="text-error text-small" key={errors}>
              {this.props.t(errors)}
            </span>
          )
        ) : (
          <div className="description">{description}</div>
        )}

        <div
          className={`${className || ''} options ${
            title || description || errors ? 'checkbox-list-options' : ''
          }`}>
          {checkboxes.map((checkbox) => this.getCheckbox(checkbox))}
        </div>

        {this.props.children}
      </div>
    );
  }
}

CheckboxList.propTypes = {
  onChange: PropTypes.func.isRequired,
  checkboxes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  disabledList: PropTypes.bool,
  errors: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  className: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  required: PropTypes.bool,
  children: PropTypes.node,
  t: PropTypes.func.isRequired,
};

CheckboxList.defaultProps = {
  disabledList: false,
};

export default withTranslation()(CheckboxList);
